module.exports = __webpack_public_path__ + "static/media/if20-icon.d140b4c9.svg";